import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PopoverContent } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

const StyledPopoverContent = styled(PopoverContent)`
    background-color: ${colorsPalettes.carbon[500]};
    color: ${colorsPalettes.bluegrey[100]};
`;

export const StyledVisitsContent = styled(Stack)`
    gap: 16px;
`;
